import { useTranslation } from "react-i18next";
import { useBisacCatalogueQuery } from "~/components/bisac-codes/hooks/use-bisac-catalogue-query";
import { InfoTooltip } from "~/components/info-tooltip";
import { TabHeader } from "~/components/tab-header";

export const BisacCodesHeader = () => {
  const { t } = useTranslation("bisacCodes");
  const edition = useBisacCatalogueQuery().data?.edition;

  return (
    <TabHeader
      title={t("bisacCodes:header.title")}
      subtitle={
        <span className="inline-flex items-center gap-1">
          {t("bisacCodes:header.description")}
          {edition && (
            <InfoTooltip
              label={t("bisacCodes:header.editionLabel")}
              text={t("bisacCodes:header.edition", { edition })}
              iconSize="small"
            />
          )}
        </span>
      }
    />
  );
};
